import { defaults } from 'lodash';
import { makeAsyncAction } from '../../../ui-lottery';
import * as types from '../constants/actions';
import { SearchDefaults } from '../props/search';

export const saveSearch = makeAsyncAction(types.SEARCH, (query) => () => Promise.resolve({ data: defaults({}, query, SearchDefaults) }));
